export const YAKIT = ["Benzin", "Dizel", "Hibrit", "Benzin+LPG", "Elektrik"];
export const VITES = ["Manuel", "Otomatik"];
export const DURUM = ["Stokta", "Satıldı", "Rezerve"];
export const MASRAF_KATEGORI = [
  "Tamir/Bakım",
  "Lastik",
  "Detaylı Temizlik",
  "Muayene",
  "Diğer",
];
export const GIDER_KATEGORI = [
  "Maaş",
  "Kira",
  "Fatura",
  "Vergi",
  "Reklam",
  "Diğer",
];
export const ODEME_YONTEMI = ["Nakit", "Kredi Kartı", "Havale-EFT"];

export const vehicleCost = (v) =>
  (Number(v.alisFiyati) || 0) +
  (v.masraflar || []).reduce((s, m) => s + (Number(m.tutar) || 0), 0);

export const vehicleProfit = (v) => {
  if (v.durum !== "Satıldı") return 0;
  return (Number(v.satisFiyati) || 0) - vehicleCost(v);
};
